module.exports = __webpack_public_path__ + "img/pic23.266acb21.jpg";